import api from "@/api/gistracker-api";
import RemoteCrudService from "./remote-crud-service"

export default class GisTrackerCrudService extends RemoteCrudService {

  constructor(mnemonic) {
    super(mnemonic);
    this.id = 0;
  }

  async get() {
    if (this.id > 0) {
      return await api.tracker.get(this.id);
    } else {
      return await this.createDefault();
    }
  }

  async save(patch, returnEntireModel = true) {
    if (this.isNew()) {
      await api.tracker.create(patch);
    } else {
      await api.tracker.update(
        this.id,
        patch
      );
    }

    if (returnEntireModel) {
      return await this.get();
    } else {
      let res = patch;
      res.ID = this.id;
      return res;
    }
  }

  async delete() {
    await api.tracker.delete(this.id);
  }

  async restore() {
    await api.tracker.restore(this.id);
  }
}
